import React, {ReactNode, useMemo} from 'react';
import {StockXFilterProvider} from 'modules/stock-x/provider/StockXFilterProvider';
import {TGetListingTransformedResponse} from 'plugins/modules/listing/types';
import {IProductShort} from 'modules/products/types';
import {TGetListingRequest} from 'plugins/modules/listing/api/api';
import {SORT_LIST} from 'modules/products/constants';
import {ListingProvider} from 'plugins/modules/listing/provider';
import {useLazyGetStockProductsQuery} from 'modules/stock-x/services';
import {useExpressOrderStoreId} from 'modules/express-order/hooks/useExpressOrderStoreId';

interface IProps {
    children: ReactNode;
    initialData: TGetListingTransformedResponse<IProductShort>;
    initialArgs: TGetListingRequest<{section?: string; tabId?: string}>;
}

export const StockXPageProvider = ({children, initialArgs, initialData}: IProps) => {
    const expressOrderStoreId = useExpressOrderStoreId(initialArgs.expressOrderStoreId);

    const dynamicQueryArgs = useMemo(() => ({expressOrderStoreId}), [expressOrderStoreId]);

    return (
        <ListingProvider
            sortList={SORT_LIST}
            initialArgs={initialArgs}
            initialData={initialData}
            pageType={'STOCK_X'}
            lazyQuery={useLazyGetStockProductsQuery}
            dynamicQueryArgs={dynamicQueryArgs}
        >
            <StockXFilterProvider>{children}</StockXFilterProvider>
        </ListingProvider>
    );
};
